<template>
  <el-row :gutter="10" v-if="loaded" :style="(isWindowSize('sm'))?'margin-top: 10px;':''">
    <el-col :xs="4" :sm="2">
      <el-popover placement="top-start" :width="optimalWidth" trigger="click">
        <el-row class="tall-row">
          <el-input placeholder="ψαξε..." v-model="content.search" clearable></el-input>
        </el-row>
        <el-row class="tall-row">
          <s-tag-select
            style="width:100%"
            multiple
            filterable
            placeholder="Για τί πρόκειται..."
            v-model="content.tagss"
            :end-point="qTags"
            value-prop="tags"
            label-prop="tags"
            :allowAdd="false"
          ></s-tag-select>
        </el-row>
        <el-row class="tall-row">
          <el-col :span="12">
            <el-select
              
              v-model="content.paymenttype"
              placeholder="Τροπος Πληρωμης"
              clearable
              filterable
            >
              <el-option key="cash" label="Μετρητα" value="cash"></el-option>
              <el-option key="bank" label="Τραπεζα" value="bank"></el-option>
              <el-option key="visa" label="VISA" value="visa"></el-option>
              <el-option key="stock" label="Πιστοτικο" value="stock"></el-option>
              <el-option key="other" label="Αλλο" value="other"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            <s-tag-select
              style="width:100%"
              multiple
              filterable
              placeholder="Που.."
              v-model="content.place"
              :end-point="qPlaces"
              :allowAdd="false"
              value-prop="place"
              label-prop="place"
            ></s-tag-select>
          </el-col>
        </el-row>

        <el-row class="tall-row">
          <el-switch
            v-model="content.active"
            :title="content.active?'παρουσιαζοντε μονο οι ενεργες':'παρουσιαζοντε ολες'"
            inactive-icon-class="el-icon-circle-close"
            inactive-text="Ολες"
            active-icon-class="el-icon-circle-check"
            active-text="Ενεργες"
          ></el-switch>
        </el-row>
        <el-button slot="reference" type="text">
          <i class="material-icons" v-if="noFilters">search</i>
          <i class="material-icons" v-else style="color:red">zoom_out</i>
        </el-button>
      </el-popover>
    </el-col>
    <el-col :sm="22" :xs="20">
      <ctk-dater
        v-model="content.searchdaterange"
        range-by-seprator="-"
        range
        export-format="dd/mm/yy"
        :customiseShortcuts="dtshorts"
      ></ctk-dater>
      <!-- <r-dater v-model="content.searchdaterange" range-by-seprator="-"></r-dater> -->
    </el-col>
  </el-row>
</template>

<script>
// pattern="^([0]?[1-9]|[1|2][0-9]|[3][0|1])/([0]?[1-9]|[1][0-2])/(19|20)\d\d$"
import * as dateHelper from "date-fns";
export default {
  name: "r-searcher",
  data() {
    return {
      dtshorts: [
        { key: "lastWeek", label: "Πργ. Εβδομ." },
        { key: "thisWeek", label: "Τρχ. Εβδομ." },

        {
          key: "nextWeek",
          label: "Επμ. Εβδομ."
        },
        // { key: "last7Days", label: "Last 7 days", value: 7 },
        // { key: "last30Days", label: "Last 30 days", value: 30 },
        { key: "lastMonth", label: "Πργ. Μήνας" },
        { key: "thisMonth", label: "Τρχ. Μηνας" },

        {
          key: "nextMonth",
          label: "Επμ. Μηνας"
        },
        { key: "lastYear", label: "Πργ. Ετος" },
        { key: "thisYear", label: "Φέτος" }
      ],
      loaded: false,
      content: { searchdaterange: null, active: true, search: null }
    };
  },
  props: {
    value: { default: null }
  },
  computed: {
    noFilters(){
      return !this.content.search&&this.content.active&&!this.content.tagss&&!this.content.place&&!this.content.paymenttype
    },
    optimalWidth() {
      return window.innerWidth < 600 ? window.innerWidth - 20 : 400;
    }
  },
  watch: {
    content: {
      handler: function(val, oldVal) {
        _log_("ela re...", val);
        this.$emit("input", val);
        this.$emit("change", val);
      },
      deep: true
    }
  },
  created() {
    if (this.value) this.content = this.value;
    const date = new Date();
    this.loaded = true;
    // this.content = [date.getTime(), date.getTime()];
  },
  mounted() {
    this.$emit("input", this.content);
  },
  methods: {
    init() {}
  }
};
</script>
<style>
.el-switch__label .el-icon-circle-check,
.el-switch__label .el-icon-circle-close {
  font-size: 20px;
}
</style>
